import "./difficulty.css";
import difficultyIcon from "../../assets/bar-chart.svg";
const DifficultyDropdown = ({ onClick, selectedDifficulty }) => {
  const difficultyData = {
    Easy: "Easy",
    Average: "Average",
    Hard: "Hard",
  };

  return (
    <div className="exam-difficulty-box">
      <label
        htmlFor="difficulty"
        className="form-label"
      >
        <img
          src={difficultyIcon}
          alt="info"
          style={{ width: "16px", height: "16px" }}
        />
        <span>Difficulty Level</span>
      </label>
      <select
        value={selectedDifficulty || ""}
        onChange={(e) => onClick(e.target.value)}
        className="difficulty-dropdown"
      >
        <option value="" disabled>
          Select Difficulty
        </option>
        {Object.entries(difficultyData).map(([difficulty, label], index) => (
          <option key={index} value={difficulty}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DifficultyDropdown;
